import { render, staticRenderFns } from "./ArtistModal.vue?vue&type=template&id=737e1020&"
import script from "./ArtistModal.vue?vue&type=script&lang=js&"
export * from "./ArtistModal.vue?vue&type=script&lang=js&"
import style0 from "./ArtistModal.vue?vue&type=style&index=0&id=737e1020&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports